
<div
  ref="svgContainer"
  class="common-icon"
  :class="type"
  :style="styles"
  @click="e => $emit('click', e)"
></div>
